import TouchGallery from "../webPage/TouchGallery";
import Track from "./Track";

export default class ProductGallery {
    constructor($element) {
        this.$element = $element;

        this.track = new Track(this.$element.find('.js-track-wrap'), {
            classes: {
                block: "slider",
            },
        });

        this.touchGallery = new TouchGallery(this.$element, {
            itemsClass: "gallery__main-wrap",
            itemClass: "gallery__main-image",
            pipClass: "gallery__thumb",
            keyboardEvents: true,
            animationDuration: 300,
            zoom: {
                enabled: true,
            },
        });

        this.touchGallery.on("transitionStart", ({from, to}) => {
            // We need to ensure that the element is within the viewport
            this.updateTrackOffset(to);
            this.updateActiveNumber(to);
        });

        this.$activeNumber = this.$element.find('.js-active-number');

        this.bindEvents();
    }


    bindEvents() {
        this.updateTrackOffset();
    }

    updateActiveNumber(to) {
        this.$activeNumber.text(to + 1);
    }

    updateTrackOffset(to = null) {
        if (to === null) {
            to = this.touchGallery.gallery.getActiveIndex();
        }
        let $to = this.track.getItems().eq(to);


        let offsetLeft = "undefined" === typeof $to.position() ? 0 : $to.position().left;
        let offsetRight = offsetLeft + $to.outerWidth();

        if (offsetLeft < this.track.getTransform()) {
            this.track.setTransform(offsetLeft - 4);
            return;
        }

        if (offsetRight > this.track.getTransform() + $(window).innerWidth()) {
            this.track.setTransform(offsetRight - $(window).innerWidth() + 4);
            return;
        }
    }

    destroy() {
        if (this.track) {
            this.track.destroy();
        }

        if (this.touchGallery) {
            this.touchGallery.destroy();
        }
    }
}
